/**
 * Brevitē new nav
 * File: assets/brv-nav.js (loaded only when "Use new navigation" is on)
 * Handles: menu drawer (open/close, focus trap, scroll lock, image preload, promo dates),
 * nav analytics (Shopify.analytics.publish), quick link chip swipe cue.
 *
 * Analytics debug: add ?brv_nav_debug=1 to any URL once (it sticks via localStorage),
 * then every event is also logged to the console. ?brv_nav_debug=0 turns it off.
 */

(function () {
  'use strict';

  /* ═══ ANALYTICS ═══ */
  var DEBUG = false;
  try {
    var q = new URLSearchParams(window.location.search).get('brv_nav_debug');
    if (q === '1') localStorage.setItem('brv_nav_debug', '1');
    if (q === '0') localStorage.removeItem('brv_nav_debug');
    DEBUG = localStorage.getItem('brv_nav_debug') === '1';
  } catch (e) { /* storage blocked */ }

  function device() {
    return window.matchMedia('(min-width: 990px)').matches ? 'desktop' : 'mobile';
  }

  function publish(name, data) {
    data.device = device();
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* never block navigation on analytics */ }
    if (DEBUG) console.log('[brv-nav]', name, data);
  }
  window.brvNavPublish = publish;

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-brv-nav]');
    if (!link) return;
    publish('nav_click', {
      location: link.getAttribute('data-brv-nav'),
      label: link.getAttribute('data-brv-label') || link.textContent.trim(),
      position: parseInt(link.getAttribute('data-brv-pos'), 10) || 0
    });
  });

  /* ═══ DRAWER ═══ */
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var drawerApi = null;

  function initDrawer() {
    /* After a theme-editor re-render, drop the copy moved to <body> last time */
    document.querySelectorAll('body > [data-brv-drawer]').forEach(function (el) { el.remove(); });

    var drawer = document.querySelector('[data-brv-drawer]');
    var burger = document.querySelector('[data-brv-burger]');
    if (!drawer || !burger) { drawerApi = null; return; }

    /* Live under <body> so no header stacking context or transform can trap it */
    document.body.appendChild(drawer);

    var panel = drawer.querySelector('.brv-drawer__panel');
    var closeBtn = drawer.querySelector('.brv-drawer__close');
    var isOpen = false;
    var hideTimer = null;

    function hydrate(imgs) {
      Array.prototype.forEach.call(imgs, function (img) {
        if (!img.hasAttribute('data-brv-src')) return;
        if (img.hasAttribute('data-brv-srcset')) img.srcset = img.getAttribute('data-brv-srcset');
        img.src = img.getAttribute('data-brv-src');
        img.removeAttribute('data-brv-src');
        img.removeAttribute('data-brv-srcset');
      });
    }

    /* Pages are cached, so re-check the promo dates in the browser: first in-window promo wins */
    function pickPromo() {
      var now = Date.now() / 1000;
      var found = null;
      drawer.querySelectorAll('[data-brv-promo]').forEach(function (p) {
        var s = parseInt(p.getAttribute('data-start'), 10) || 0;
        var e = parseInt(p.getAttribute('data-end'), 10) || 0;
        var ok = !found && s <= now && (!e || e >= now);
        p.hidden = !ok;
        if (ok) found = p;
      });
      return found;
    }

    function preload() {
      var promo = pickPromo();
      hydrate(drawer.querySelectorAll('img[data-brv-early]'));
      if (promo) hydrate(promo.querySelectorAll('img'));
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      clearTimeout(hideTimer);
      pickPromo();
      hydrate(drawer.querySelectorAll('img'));
      drawer.hidden = false;
      document.documentElement.classList.add('brv-nav-lock');
      burger.setAttribute('aria-expanded', 'true');
      void drawer.offsetWidth; /* start the transition from the closed state */
      drawer.classList.add('is-open');
      if (typeof window.trapFocus === 'function') { window.trapFocus(panel, closeBtn); } else { closeBtn.focus(); }
      publish('nav_open', {});
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      drawer.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('brv-nav-lock');
      if (typeof window.removeTrapFocus === 'function') { window.removeTrapFocus(burger); } else { burger.focus(); }
      hideTimer = setTimeout(function () { drawer.hidden = true; }, reducedMotion.matches ? 0 : 220);
    }

    burger.addEventListener('click', function () { if (isOpen) { close(); } else { open(); } });
    /* Warm the first 4 tile photos + promo before the tap lands */
    ['touchstart', 'mouseenter', 'focus'].forEach(function (ev) {
      burger.addEventListener(ev, preload, { once: true, passive: true });
    });
    drawer.querySelectorAll('[data-brv-close]').forEach(function (el) { el.addEventListener('click', close); });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); close(); }
    });

    drawerApi = { open: open, close: close, drawer: drawer };
  }

  /* Theme editor: selecting a drawer tile/promo block opens the drawer (and shows that promo) */
  document.addEventListener('shopify:block:select', function (e) {
    if (!drawerApi || !drawerApi.drawer.contains(e.target)) return;
    drawerApi.open();
    if (e.target.hasAttribute('data-brv-promo')) {
      drawerApi.drawer.querySelectorAll('[data-brv-promo]').forEach(function (p) { p.hidden = p !== e.target; });
    }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    if (drawerApi && drawerApi.drawer.contains(e.target)) drawerApi.close();
  });
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector && e.target.querySelector('[data-brv-hdr]')) { initDrawer(); initChips(); }
  });

  /* ═══ CHIP ROW SWIPE CUE ═══ */
  function initChips() {
    var wrap = document.querySelector('[data-brv-chips]');
    if (!wrap) return;
    var list = wrap.querySelector('[data-brv-chips-scroller]');
    var chips = list.querySelectorAll('.brv-ql');
    if (!chips.length) return;

    var BASE_PAD = 16;

    function edgeState() {
      var scrollable = list.scrollWidth > list.clientWidth + 1;
      wrap.classList.toggle('is-scrollable', scrollable);
      wrap.classList.toggle('is-end', !scrollable || list.scrollLeft + list.clientWidth >= list.scrollWidth - 2);
    }

    /* Make sure the first chip that doesn't fit shows at least 32px and is cut
       by at least 24px, so it reads as "more this way". */
    function nudge() {
      var pad, i, j, chip, left, width, shown, ok;
      for (i = 0; i <= 12; i++) {
        pad = BASE_PAD + (i % 2 ? -1 : 1) * Math.ceil(i / 2);
        for (j = 0; j < chips.length; j++) chips[j].style.paddingInline = pad + 'px';
        if (list.scrollWidth <= list.clientWidth + 1) break;
        ok = false;
        for (j = 0; j < chips.length; j++) {
          chip = chips[j];
          left = chip.offsetLeft - list.offsetLeft;
          width = chip.offsetWidth;
          if (left + width > list.clientWidth) {
            shown = list.clientWidth - left;
            ok = shown >= 32 && width - shown >= 24;
            break;
          }
        }
        if (ok) break;
      }
      edgeState();
    }

    /* On the page a chip links to (e.g. /collections/clearance), bring that chip
       into view so shoppers can see where they are. */
    function showCurrent() {
      var current = list.querySelector('[aria-current="page"]');
      if (!current) return;
      var item = current.parentElement;
      var gutter = parseFloat(getComputedStyle(list).paddingLeft) || 0;
      var left = item.offsetLeft - list.offsetLeft;
      if (left + item.offsetWidth <= list.clientWidth - gutter) return;
      list.scrollLeft = Math.min(left - gutter, list.scrollWidth - list.clientWidth);
      edgeState();
    }

    function layout() { nudge(); showCurrent(); }

    list.addEventListener('scroll', edgeState, { passive: true });
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(layout, 100); });
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(layout); } else { layout(); }
  }

  function init() {
    initDrawer();
    initChips();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
